
import { Component } from '@angular/core';
import { ViewController, NavController } from 'ionic-angular';
import { ChatDetailsPage } from './chat-details';
import { ChatService } from '../../services/chat.service';
import { AlertService } from '../../providers/alert.service';
import { ImService } from "./im.service";
import { App } from 'ionic-angular/components/app/app';
import { SigninPage } from '../signin/signin';
import { StorageService } from '../../providers/storage.service';
import { SysconfigService } from '../../services/sysconfig.service';

@Component({
    selector: 'page-friendlistpage',
    templateUrl: 'friend-list.html',
    providers: [
        ChatService,
        ImService
    ]
})
export class FriendListPage {
    subUser = [

    ];   // 所有下级
    upUser: string;    //上级用户名
    isShowUpUser: boolean = true; // 好友列表是否显示上级
    IsBanned: boolean = false;     // 可以进去聊天界面，但是输入框是禁用的
    IsBlacklist: boolean = false;    // 黑名单的，聊天界面都不能进去
    constructor(
        private viewCtrl: ViewController,
        private navCtrl: NavController,
        private chat: ChatService,
        private alert: AlertService,
        private appCtrl: App
    ) { }

    ionViewDidLoad() {
        this.getUpUser();
        this.getSubUsers();
        this.getImToker();
    }
    // 获取上级
    getUpUser() {
        this.chat.getUpUser().then(s => {
            if (s) {
                this.upUser = s.UserName;
                this.isShowUpUser = true;
            } else {
                this.isShowUpUser = false;
            }
        }).catch(err => {
            if (err.status === 401 || err.status === 403) {
                this.alert.showAlert("验证已失效，您需要退出重新登录!");
                clearInterval(ImService.getMessageCount);
                clearInterval(ImService.getHistoryList);
                clearInterval(ImService.getMessageList);
                localStorage.clear();
                this.appCtrl.getRootNav().setRoot(SigninPage);
            }
        })
    }
    // 获取下级
    getSubUsers() {
        this.chat.getSubUsers().then(s => {
            if (s.length > 0) {
                s.forEach(user => {
                    this.subUser.push(user.UserName);
                });
            }
        }).catch(err => {
            if (err.status === 401 || err.status === 403) {
                this.alert.showAlert("验证已失效，您需要退出重新登录!");
                clearInterval(ImService.getMessageCount);
                clearInterval(ImService.getHistoryList);
                clearInterval(ImService.getMessageList);
                localStorage.clear();
                this.appCtrl.getRootNav().setRoot(SigninPage);
            }
        })
    }
    // 获取黑名单配置
    getImToker() {
        this.chat.GetChatUserBannedAsync().then(s => {
            this.IsBanned = s.Parameter2.IsBanned;
            this.IsBlacklist = s.Parameter2.IsBlacklist;
        },err=>{
            
        })
    }
    chatDetails(getName) {
        if (this.IsBlacklist) {
            this.alert.showAlert('您已被禁言，请联系客服!');
            return;
        } else {
            var sendName = getName;
            if (getName == '上级代理') {
                sendName = this.upUser;
            }
            this.navCtrl.push(ChatDetailsPage, {
                FromUserName: sendName
            });
        }
    }
    dismiss() {
        this.viewCtrl.dismiss();
    }
}



// WEBPACK FOOTER //
// ./src/pages/im/friend-list.ts